import ModelPage from './model.container';

export default ModelPage;